import { motion } from "framer-motion";
import { BookOpen, Download, FileText, ShieldCheck, Wrench, Cpu, Plug, CalendarClock, LifeBuoy } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const MANUAL_PDF = "/downloads/IshuCar-Owners-Manual.pdf";

const CHAPTERS = [
  { n: "01", icon: BookOpen, title: "Welcome", text: "IshuCar family में स्वागत — हमारा promise और Founding Owner benefits।" },
  { n: "02", icon: BookOpen, title: "The Line-up", text: "Aero D, SUV और Electric — variants, specs और prices की पूरी table।" },
  { n: "03", icon: CalendarClock, title: "Booking & Delivery", text: "₹10,000 refundable token से January 2028 delivery तक — step by step।" },
  { n: "04", icon: Cpu, title: "Auto Drive Mode", text: "कैसे on करें, कैसे काम करता है और safety rules — आप relax, car खुद चले।" },
  { n: "05", icon: Plug, title: "Charging Guide", text: "DC fast, 11 kW wallbox और Solar Assist Roof — daily routine सहित।" },
  { n: "06", icon: Wrench, title: "₹300 Lifetime Servicing", text: "क्या cover होता है, service schedule और booking process।" },
  { n: "07", icon: ShieldCheck, title: "Warranty", text: "15-year battery warranty + vehicle warranty — claim करने का तरीका।" },
  { n: "08", icon: FileText, title: "Safety & Connectivity", text: "ADAS, airbags, SOS और app features — remote control सब कुछ।" },
  { n: "09", icon: LifeBuoy, title: "FAQ & Contact", text: "सबसे आम सवालों के जवाब + support@ishukart.com।" },
];

export default function Manual() {
  return (
    <div className="mx-auto max-w-5xl px-5 pb-24 pt-40 sm:px-8" data-testid="manual-page">
      <Reveal className="text-center">
        <p className="eyebrow">E-Book</p>
        <h1 className="mt-4 font-display text-4xl font-extrabold uppercase text-white sm:text-5xl">
          Owner's <span className="text-gold-gradient">Manual</span>
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-sm leading-relaxed text-neutral-400 sm:text-base">
          आपकी IshuCar का पूरा e-book manual — booking से delivery, Auto Drive से charging,
          ₹300 servicing से 15-year battery warranty तक। 9 chapters, सब एक PDF में।
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-4">
          <a
            href={MANUAL_PDF}
            download="IshuCar-Owners-Manual.pdf"
            data-testid="manual-download-button"
            className="inline-flex items-center gap-2.5 rounded-full bg-[#e6b800] px-8 py-4 font-bold text-[#070709] transition-all duration-200 hover:bg-[#ffc700] hover:shadow-[0_0_40px_rgba(230,184,0,0.5)]"
          >
            <Download size={17} /> E-Book Manual डाउनलोड करें (PDF)
          </a>
          <a
            href={MANUAL_PDF}
            target="_blank"
            rel="noreferrer"
            data-testid="manual-read-button"
            className="inline-flex items-center gap-2.5 rounded-full border border-white/15 px-7 py-4 text-sm font-semibold text-white transition-colors duration-200 hover:border-[#e6b800]/60 hover:text-[#e6b800]"
          >
            <BookOpen size={16} /> बिना download पढ़ें
          </a>
        </div>
        <p className="mt-3 font-mono2 text-[10px] uppercase tracking-[0.25em] text-neutral-600">
          9 pages · Edition 2026 · हर booking के साथ free
        </p>
      </Reveal>

      <div className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {CHAPTERS.map((ch, i) => (
          <Reveal key={ch.n} delay={i * 0.04}>
            <motion.div whileHover={{ y: -4 }} className="card-glow h-full rounded-2xl p-6" data-testid={`manual-chapter-${ch.n}`}>
              <div className="flex items-center justify-between">
                <span className="flex h-10 w-10 items-center justify-center rounded-xl border border-[#e6b800]/30 bg-[#e6b800]/10 text-[#e6b800]">
                  <ch.icon size={17} />
                </span>
                <span className="font-mono2 text-[11px] font-bold tracking-[0.2em] text-neutral-600">{ch.n}</span>
              </div>
              <h2 className="mt-4 font-display text-base font-bold uppercase text-white">{ch.title}</h2>
              <p className="mt-2 text-xs leading-relaxed text-neutral-400">{ch.text}</p>
            </motion.div>
          </Reveal>
        ))}
      </div>

      <Reveal className="mt-12">
        <div className="rounded-2xl border border-white/10 bg-[#0a0a0e] p-8 text-center">
          <p className="text-sm leading-relaxed text-neutral-400">
            Manual में कुछ सुझाव? Email करें —{" "}
            <a href="mailto:support@ishukart.com" className="text-[#e6b800] hover:underline">
              support@ishukart.com
            </a>
          </p>
        </div>
      </Reveal>
    </div>
  );
}
